import type { ResponsiveTween } from '@/common/tweens';
import { lerp } from '@lemonade-hq/ts-helpers';
import type React from 'react';
import { keyframes } from 'styled-components';

// ANIMATIONS

export const textRiseAnimationMobile = keyframes`
    0% {
        transform: translateY(25px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
`;

export const textRiseAnimation = keyframes`
    0% {
        transform: translateY(50px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
`;

// TWEEN

export const riseTween: ResponsiveTween<React.CSSProperties> = [
  t => {
    return {
      opacity: lerp(0, 1, t),
      transform: `translateY(${lerp(22, 0, t)}px)`,
      willChange: 'opacity, transform',
    };
  },
  t => {
    return {
      opacity: lerp(0, 1, t),
      transform: `translateY(${lerp(22, 0, t)}px)`,
      willChange: 'opacity, transform',
    };
  },
  t => {
    return {
      opacity: lerp(0, 1, t),
      transform: `translateY(${lerp(50, 0, t)}px)`,
      willChange: 'opacity, transform',
    };
  },
];

export const riseAlotTween: ResponsiveTween<React.CSSProperties> = [
  t => {
    return { transform: `translateY(${lerp(0, -500, t)}px)` };
  },
  t => {
    return { transform: `translateY(${lerp(0, -500, t)}px)` };
  },
  t => {
    return { transform: `translateY(${lerp(0, -850, t)}px)` };
  },
];
